import { render, staticRenderFns } from "./modalVerDetalleSAV.vue?vue&type=template&id=4e913da6&"
import script from "./modalVerDetalleSAV.vue?vue&type=script&lang=ts&"
export * from "./modalVerDetalleSAV.vue?vue&type=script&lang=ts&"
import style0 from "./modalVerDetalleSAV.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports